<template>
	<div class="main-content" v-loading="loading">
		<div class="cart-content" v-if="!loading">
			<div style="padding: 0 20px;">
				<div class="cart-title">订单结算</div>
				<div class="step-progress">
					<div class="step-slider step-active">商品分类<span class="iconfont iconchangjiantou-you"></span></div>
					<div class="step-slider step-active">购物车<span class="iconfont iconchangjiantou-you"></span></div>
					<div class="step-slider step-active">确认订单<span class="iconfont iconchangjiantou-you"></span></div>
					<div class="step-slider">审核订单<span class="iconfont iconchangjiantou-you"></span></div>
					<div class="step-slider">总部受理订单</div>
				</div>
				<div class="box-con-tit">
					<div class="mb10"><span>要货日期：{{demand_date}}</span>
						<div v-if='address.address' style="display: inline-block;"><span class="ml50">收货地址：<span class="bottom-line">{{address.address}}</span></span>
							<span class="ml50">联系人：<span class="bottom-line">{{address.name}}</span></span>
							<span class="ml50">联系电话：<span class="bottom-line">{{address.tel}}</span></span> </div> <button class="ml50 bnt-buy"
						 style="background: rgb(89, 109, 230);" @click="openAddress()">
							选择地址
						</button>
					</div>
					<div>备注：<div class='remark-input'>
							<el-input placeholder="请输入备注" v-model='remark'></el-input>
						</div>
					</div>
				</div>
				<el-table :data="tableData" height="500" border>
					<el-table-column label="序号" type="index" min-width="8%">
					</el-table-column>
					<!-- <el-table-column label="操作" min-width="8%" >

					<template slot-scope="scope">
						<el-button @click.native.prevent="deleteItem(scope.$index)" type="text" size="small">
							册除
						</el-button>
					</template>
				</el-table-column> -->
					<el-table-column prop="name" label="商品名称" min-width="28%">
					</el-table-column>
					<el-table-column prop="sku_name" label="规格型号" min-width="8%">
					</el-table-column>
					<el-table-column prop="mnemonic_code" label="助记码" min-width="8%">
					</el-table-column>
					<el-table-column prop="barcode" label="条形码" min-width="8%">
					</el-table-column>
					<el-table-column prop="sale_price_unit_qty" label="订货数量" min-width="8%">
					</el-table-column>
					<el-table-column prop="sale_unit" label="计量单位" min-width="8%">
					</el-table-column>
					<el-table-column prop="sale_unit_qty" label="件数" min-width="8%">
					</el-table-column>
					<el-table-column prop="price" label="单价" min-width="8%">
					</el-table-column>
					<el-table-column prop="subtotal_price" label="金额" min-width="8%">
					</el-table-column>
				</el-table>
				<div class="amount-total">
					<span class="mr20">总件数：{{dataInfo.sale_unit_qty}}</span>
					<span class="mr20">总数量：{{dataInfo.sale_price_unit_qty}}</span>
					<span class="mr20">总金额：<span class="text-red">{{dataInfo.total_price}}</span> </span>
					<router-link to="/cart" replace>返回购物车</router-link>
					</button>
					<button class="bnt-submit" @click="confirm()">确认订单</button>
				</div>
			</div>
		</div>
		<div v-if="mask"><Address @selectFunc="selectFunc" :selectValue="address"></Address></div>
	</div>

</template>

<script>
	import Vheader from '@/views/header'
	import Address from '@/components/address'
	export default {
		name: 'pay',
		data() {
			return {
				tableData: [],
				loading: true,
				dataInfo: {},
				address: [],
				demand_date: '',
				remark: '',
				disable: false,
				mask: false,
				address: {}
			}
		},
		created: function() {
			this.reload();
			// this.address = this.$store.state.address;
			this.GetDateStr();
		},
		components: {
			Address: Address
		},
		methods: {
			openAddress: function() {
				this.mask = true;
			},
			selectFunc: function(e) {
				this.address = e;
				this.mask = false;
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			GetDateStr: function() {
				var dd = new Date();
				dd.setDate(dd.getDate() + 6); //获取AddDayCount天后的日期 
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1; //获取当前月份的日期 
				var d = dd.getDate();
				this.demand_date = y + "-" + m + "-" + d;
			},
			reload: function() {
				var me = this;
				this.https.fetchGet('/pc/service/trade/cart/index').then((res) => {
					if (res.data.success) {
						var data = res.data.content;
						var value = [];
						for (var i=0;i<data.rows.length;i++) {
							if (data.rows[i].checked == '1') {
								value.push(data.rows[i]);
							}
						}
						me.tableData = value;
						me.dataInfo = data;
						me.loading = false;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			confirm: function() {

				if (this.address.name) {
					if (this.disable) return;
					this.disable = true;
					var params = {
						consignee_name: this.address.name,
						consignee_mobile: this.address.tel,
						consignee_address: this.address.address,
						demand_date: this.demand_date,
						remark: this.remark,
						consignee_address_no:this.address.address_no
					}
					this.https.fetchPost('/pc/service/trade/order/submit', params).then((res) => {
						this.disable = false;
						if (res.data.success) {
							this.$router.replace({
								name: 'paysuccess',
								query: {
									'id': res.data.content.id
								}
							})
							Vheader.methods.getCartItemsCount();
						}
					}).catch(err => {
						this.disable = false;
						console.log(err)
					})
				} else {
					this.$message({
						type: 'success',
						message: '请选择收货地址'
					});
				}
			}
		}
	}
</script>

<style scoped>
	.cart-content {
		background: #fff;
		/* min-width: 1500px; */
	}

	.main-content {
		padding: 20px;
	}

	.el-table td {
		text-align: center;
	}

	.el-table th.is-leaf {
		background-color: rgb(74, 144, 138);
		color: #fff;
		text-align: center;
	}

	.step-progress {
		float: right;
		padding: 10px 0;
	}

	.cart-title {
		display: inline-block;
		padding: 10px 0;
	}

	.amount-total {
		text-align: right;
		height: 50px;
		margin-right: 50px;
		margin-top: 20px;
	}

	.bnt-buy {
		background: rgb(74, 144, 138);
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.bnt-submit {
		background: red;
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.mr20 {
		margin-right: 20px;
	}

	.ml50 {
		margin-left: 50px;
	}

	.text-red {
		color: red;
	}

	.box-con-tit {
		background: #fff;
		padding: 20px 20px 20px 0;
		//margin-left: 50px;
	}

	.mb10 {
		margin-bottom: 10px;
	}

	.bottom-line {
		border-bottom: 1px solid #999;
		padding: 0 5px 5px 5px;
	}

	.remark-input {
		display: inline-block;
		width: 400px;
		margin-top: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/pay.vue